export default __webpack_public_path__ + "static/media/mail.001ac9ff.svg";